import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { steps } from './Dialog';
import { useLinesContext } from '../../../contexts/Lines';
import CustomTooltip from '../../BuildingBlocks/Tooltip/Tooltip';
import Dialog from '../../BuildingBlocks/Dialogs/DialogStyleTwo/Dialog';
import UploadCard from '../../../components/uploadDocument/UploadCard';
import CancelButton from '../../BuildingBlocks/Button/CancelButton';
import LoadingButton from '../../lowLevel/LoadingButton';

const useStyles = makeStyles((theme: any) => ({
  textArea: {
    boxSizing: 'inherit',
    minWidth: '100%',
    maxWidth: 'inherit',
    fontSize: 'large',
    height: '120px',
    resize: 'none',
    backgroundColor: theme.palette.brand.greyLight,
    borderRadius: '10px',
  },
  loadingCircle: {
    marginTop: theme.spacing(1),
  },
  gapBetweenButtons: {
    marginRight: 'auto',
  },
}));

export default function AddMessage({
  changes,
  setChangedRequestInfo,
  setStepNumber,
  open,
  endRequest = null,
}) {
  const classes = useStyles();
  const [message, setMessage] = useState('');
  const [files, setFiles] = useState([]);
  const [ids, setIds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingSubmitButton, setLoadingSubmitButton] = useState(false);
  const { editActiveLineSubmit } = useLinesContext();

  const onChange = (e) => {
    setMessage(e.target.value);
  };

  const slowSales = changes.adjustMyRemittanceScheduleOnly;
  const optional =
    changes.cancelLine ||
    (changes.LineDetailsChanged && !changes.LineDateChanged);
  const disabledTooltip =
    message === '' || (!optional && files.length === 0) || loading;

  const headerMessage = () => {
    let message = '';
    if (changes.messageOnly || changes.cancelLine)
      message += 'Things change! We get it.';

    if (!changes.messageOnly)
      message += `You're about to submit a request \n to edit an Active Line.`;

    return message;
  };

  const header = slowSales ? 'Update Sales Forecast' : headerMessage();

  const description = () => {
    let message = '';
    if (changes.messageOnly || changes.cancelLine)
      message +=
        'Our flexible Growth Plans adjust to your business, not the other way around. ';

    if (changes.cancelLine)
      message += 'Tell us about why you’re requesting to cancel this Line.\n ';
    else message += "Tell us about the change you'd like to make, and why.\n ";

    if (!changes.messageOnly)
      message +=
        "If you didn't mean to do this, simply close this pop-up. \n To proceed, submit below.";

    return message;
  };

  const content = (
    <>
      <textarea
        onChange={onChange}
        placeholder="Required: Tell us why you're making this request."
        value={message}
        name="message"
        id="message"
        className={classes.textArea}
      />
      <UploadCard
        optionalDoc={optional}
        files={files}
        setFiles={setFiles}
        setIds={setIds}
        ids={ids}
        loading={loading}
        setLoading={setLoading}
        changes={changes}
        setChangedRequestInfo={setChangedRequestInfo}
      />
    </>
  );
  const submitRequest = async () => {
    if (!disabledTooltip) {
      setChangedRequestInfo({
        ...changes,
        messageAdded: message,
        files: ids,
      });
      try {
        setLoadingSubmitButton(true);
        await editActiveLineSubmit(message, changes, changes.files);
        setLoadingSubmitButton(false);
        setStepNumber(steps.submitRequest);
      } catch (e) {
        setLoadingSubmitButton(false);
        return;
      }
    }
  };

  const action = (
    <>
      <CancelButton
        onCancel={() => endRequest(true)}
        CancelText={'Cancel Request'}
        className={classes.gapBetweenButtons}
        disabled={loadingSubmitButton}
      />
      <CustomTooltip
        arrow
        title={
          'Explanation and supporting documentation required to submit a request.'
        }
        placement="top"
      >
        <div>
          <LoadingButton
            variant="contained"
            color="primary"
            disabled={loadingSubmitButton}
            loading={loadingSubmitButton}
            onClick={submitRequest}
          >
            <b>Submit Request</b>
          </LoadingButton>
        </div>
      </CustomTooltip>
    </>
  );

  return (
    <Dialog
      open={open}
      header={header}
      children={content}
      description={description()}
      actions={action}
      onClose={() => (!loading ? endRequest(true) : null)}
    />
  );
}
